import { render, staticRenderFns } from "./ReferralCommentHistory.vue?vue&type=template&id=ee9687c4&scoped=true"
import script from "./ReferralCommentHistory.vue?vue&type=script&lang=js"
export * from "./ReferralCommentHistory.vue?vue&type=script&lang=js"
import style0 from "./ReferralCommentHistory.vue?vue&type=style&index=0&id=ee9687c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee9687c4",
  null
  
)

export default component.exports